import { CartAccommodationItem } from "@/stores/EngineStore/interfaces/CartAccommodationItem.ts";
import _isEqual from "lodash/isEqual";

export const areCartAccItemsDeeplyEqual = (
  prevCartAccommodationItems: CartAccommodationItem[],
  cartAccommodationItems: CartAccommodationItem[],
) => {
  // excluded are properties that are not relevant for the comparison (they will be skipped)
  //      parcelVehicleType
  //      parcelVehicleDimensions
  //      parcelVehicleExtraTentDimensions

  return _isEqual(
    prevCartAccommodationItems?.map((item) => ({
      id: item.id,
      mandatoryExtras: item.mandatoryExtras,
      adults: item.adults,
      children: item.children,
      optionalExtras: item.optionalExtras,
      dateRange: item.dateRange,
      ratePlan: item.ratePlan,
    })),
    cartAccommodationItems?.map((item) => ({
      id: item.id,
      mandatoryExtras: item.mandatoryExtras,
      adults: item.adults,
      children: item.children,
      optionalExtras: item.optionalExtras,
      dateRange: item.dateRange,
      ratePlan: item.ratePlan,
    })),
  );
};
